module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVQ4T2NgGBRgnYzGf3LwcDLgP5lgEBmg6Nb9nxw8nAwY2gAAOA6A2JhnpusAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NL.png
// module id = 1229
// module chunks = 0